export const VALID = 'valid';
